import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/js/flexible'
import echarts from 'echarts'
import axios from 'axios'
// import 'video.js/dist/video-js.css'
Vue.prototype.$echarts = echarts
Vue.prototype.$axios = axios
Vue.prototype.EmitEvent = new Vue();
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')